
import { computed, defineComponent, reactive } from 'vue';
import { IOption } from '@/core/models/AntDesign/IOption';
import { IParametrosConsultaRapida } from '@/core/models/Consulta/IParametrosConsultaRapida';
import { useTelaBase } from '@/core/composables/TelaBase';
import UtilitarioGeral from '@/core/utilitarios/UtilitarioGeral';
import storeSistema from '@/store/storeSistema';
import ServicoCenarioFiscal from '@/servicos/Cadastros/Tributacoes/ServicoCenarioFiscal';

export default defineComponent({
  name: 'SelecionarCenarioFiscal',
  props: {
    varios: {
      type: Boolean,
      default: false,
    },
    codigoSelecionado: {
      type: Number || undefined,
    },
    codigosSelecionados: {
      type: Array as () => number[],
      default: () => [],
    },
    empresas: {
      type: Array as () => number[],
      default: () => [],
    },
    tipoMovimento: {
      type: Number,
      default: 0,
    },
    placeholder: {
      type: String,
      default: 'Digite para selecionar',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:codigoSelecionado', 'update:codigosSelecionados', 'blur', 'change'],
  setup(props, { emit }) {
    const { montaOpcoesComListaConsultaRapida } = useTelaBase();

    let debounce = 0;
    const servicoCenarioFiscal = new ServicoCenarioFiscal();

    const state = reactive({
      listaFormasPagamento: [] as IOption[],
      fetching: false,
      emDigitacao: false,
    });

    async function obterTipoDocumentoFinanceiroPorCodigo(valor: any) {
      if (state.emDigitacao) { return; }
      if (!UtilitarioGeral.valorValido(valor)) { return; }
      if (!(valor > 0)) { return; }

      if (props.varios) {
        if (props.codigosSelecionados.length === 0) { return; }
      } else if (props.codigoSelecionado === 0) {
        return;
      }
      let efetuarConsulta = true;

      if (UtilitarioGeral.validaLista(state.listaFormasPagamento)) {
        if (props.varios) {
          const listaCodigosConsulta = state.listaFormasPagamento.map((c) => c.value);
          const diferencas = props.codigosSelecionados.filter((c) => !listaCodigosConsulta.includes(c));
          if (!UtilitarioGeral.validaLista(diferencas)) {
            efetuarConsulta = false;
          }
        } else {
          const existeLista = state.listaFormasPagamento.find((c) => c.value === props.codigoSelecionado);
          if (existeLista !== undefined) {
            efetuarConsulta = false;
          }
        }
      }

      if (!efetuarConsulta) return;

      state.listaFormasPagamento = [];

      const parametrosConsultaRapida: IParametrosConsultaRapida = {
        apenasAtivos: false, recursoAssociado: '',
      };

      if (props.varios) {
        parametrosConsultaRapida.filtrarPorVariosCodigos = true;
        parametrosConsultaRapida.valores = valor;
      } else {
        parametrosConsultaRapida.filtrarPorCodigo = true;
        parametrosConsultaRapida.valor = valor;
      }

      // if (UtilitarioGeral.validaLista(props.empresas)) {
      // parametrosConsultaRapida.empresas = props.empresas;
      // } else {
      parametrosConsultaRapida.empresas = storeSistema.getters.empresasUsuarioAutenticado();
      // }
      const listaFormasPagamento = await servicoCenarioFiscal.consultaRapidaAvancada(parametrosConsultaRapida, props.tipoMovimento);
      state.listaFormasPagamento = montaOpcoesComListaConsultaRapida(listaFormasPagamento);
    }

    async function pesquisarTipoDocumentoFinanceiro(valorPesquisa: any) {
      state.emDigitacao = true;

      if (!UtilitarioGeral.valorValido(valorPesquisa)) { return; }

      state.listaFormasPagamento = [];
      clearTimeout(debounce);
      debounce = setTimeout(async () => {
        const parametrosConsultaRapida: IParametrosConsultaRapida = {
          valor: valorPesquisa, apenasAtivos: true, recursoAssociado: '',
        };

        // if (UtilitarioGeral.validaLista(props.empresas)) {
        //  parametrosConsultaRapida.empresas = props.empresas;
        // } else {
        parametrosConsultaRapida.empresas = storeSistema.getters.empresasUsuarioAutenticado();
        // }
        const listaFormasPagamento = await servicoCenarioFiscal.consultaRapidaAvancada(parametrosConsultaRapida, props.tipoMovimento);
        state.listaFormasPagamento = montaOpcoesComListaConsultaRapida(listaFormasPagamento);
      }, 600);
    }

    function obterTipoDocumentoFinanceiro():any {
      if (props.codigoSelecionado === 0) {
        return undefined;
      }
      obterTipoDocumentoFinanceiroPorCodigo(props.codigoSelecionado);
      return props.codigoSelecionado;
    }

    const computedCodigoSelecionado = computed({
      get: () => obterTipoDocumentoFinanceiro(),
      set: (val: number) => {
        emit('update:codigoSelecionado', val);
      },
    });

    function obterCentrosCustos():number[] {
      obterTipoDocumentoFinanceiroPorCodigo(props.codigosSelecionados);
      return props.codigosSelecionados;
    }

    const computedCodigosSelecionados = computed({
      get: () => obterCentrosCustos(),
      set: (val: number[]) => {
        emit('update:codigosSelecionados', val);
      },
    });

    function blur() {
      state.emDigitacao = false;
      emit('blur');
    }

    function change() {
      emit('change');
    }

    return {
      props,
      state,
      pesquisarTipoDocumentoFinanceiro,
      computedCodigoSelecionado,
      computedCodigosSelecionados,
      blur,
      change,
    };
  },
});
